module.exports = __webpack_public_path__ + "img/page.97d80302.png";